import * as React from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormControl,
  Paper,
  Typography,
  CircularProgress
} from '@mui/material';
import { CTextField, CButton } from '../../../../components/common/Modal';

export const AdminCredentialsSection = ({ 
  isAdminCredential, 
  username, 
  password,
  showTestButton = false,
  testLoading = false,
  canTest = false,
  onAdminCredentialChange,
  onUsernameChange,
  onPasswordChange,
  onTestConnection
}) => {
  return (
    <Paper 
      elevation={1} 
      sx={{ 
        p: 2, 
        mt: '1rem', 
        border: '1px solid', 
        borderColor: 'divider',
        backgroundColor: 'background.paper'
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'medium' }}>
        Admin Credentials
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <FormControl>
          <FormControlLabel 
            control={
              <Checkbox 
                checked={isAdminCredential} 
                onChange={onAdminCredentialChange} 
              />
            } 
            label="Use Admin Credentials" 
          />
        </FormControl>
        
        {showTestButton && isAdminCredential && (
          <CButton 
            variant="outlined" 
            size="small"
            onClick={onTestConnection}
            disabled={!canTest || testLoading}
            startIcon={testLoading ? <CircularProgress size={16} /> : null}
          >
            {testLoading ? 'Testing...' : 'Test Connection'}
          </CButton>
        )}
      </Box>
      
      <CTextField
        id="username" 
        label="Username"
        size="small"
        variant="outlined"
        value={username}
        onChange={onUsernameChange}
        sx={{
          visibility: !isAdminCredential ? 'hidden': 'visible'
        }}
        fullWidth
      />          
      <CTextField
        id="password" 
        label="Password"
        type="password"
        size="small"
        variant="outlined"
        value={password}
        onChange={onPasswordChange}
        sx={{
          marginTop: '1rem',
          visibility: !isAdminCredential ? 'hidden': 'visible'
        }}
        fullWidth
      />
    </Paper>
  );
};

